import type { NetworkCallbacks } from '@atlassian/search-client';

import {
	onTaskFail,
	onTaskStart,
	onTaskSuccess,
	type TASK_NAMES,
} from './events/vital-stats-events';

type TaskNameValue = (typeof TASK_NAMES)[keyof typeof TASK_NAMES];

export type NetworkCallbackContext = {
	uxTaskId: string;
	isPreQuery?: boolean;
};

/**
 * Creates network callbacks for tracking network requests with VitalStats analytics.
 */
export const createVitalStatsNetworkCallbacks = (
	taskId: string,
	taskName: TaskNameValue,
	searchSessionId: string,
	fireAnalyticsEvent: (event: any) => void,
	configNetworkTaskStartAt: number,
	context: NetworkCallbackContext,
): NetworkCallbacks => {
	const baseParams = { taskId, task: taskName, searchSessionId };

	return {
		onStart: () => {
			fireAnalyticsEvent(onTaskStart({ ...baseParams, moreContext: context }));
		},
		onSuccess: () => {
			const timeTaken = performance.now() - configNetworkTaskStartAt;
			fireAnalyticsEvent(
				onTaskSuccess({
					...baseParams,
					moreContext: { ...context, timeTaken },
				}),
			);
		},
		onError: (errorName: string, errorMessage: string) => {
			const timeTaken = performance.now() - configNetworkTaskStartAt;
			fireAnalyticsEvent(
				onTaskFail({
					...baseParams,
					moreContext: {
						...context,
						errorName,
						errorMessage,
						timeTaken,
					},
				}),
			);
		},
	};
};

